import { createPersistedStore } from "./persisted"

export default createPersistedStore("user")
